import * as actionTypes from 'constants/actionTypes';

/**
 * Firebase doesn't obviously fit anywhere in the react-redux app structure, because it usually
 * depends on being defined globally.  Globals aren't really a thing in redux, but reducers
 * do live for the entire duration of the app.
 *
 * Therefore, storing the key pieces of the Firebase global (`app` and `auth`) here to be used
 * by saga actions later (nobody else should be touching them)
 *
 * This is a combination of the appraches used in the Appcues CRX and Firedux...
 * https://github.com/adjohnson916/firedux
 */

const initialState = {
  app: undefined,
  auth: undefined,
  authError: undefined,
  error: undefined,
  pendingWrites: {},
  lastSuccessfulWrite: 0,
  online: true,
};

export default function firebase(state = initialState, action) {
  const { payload } = action;

  switch (action.type) {
    // totally not clear but this is how auth data gets stored
    case actionTypes.UPDATE_FIREBASE_METADATA:
      return {
        ...state,
        ...payload,
      };
    case actionTypes.SET_FIREBASE_ERROR_STATUS:
      return {
        ...state,
        error: payload.error,
      };
    case actionTypes.SET_FIREBASE_AUTH_ERROR_STATUS:
      return {
        ...state,
        authError: payload,
      };
    case actionTypes.SET_FIREBASE_ONLINE_STATUS:
      return {
        ...state,
        online: payload,
      };
    case actionTypes.SET_FIREBASE_LAST_SUCCESSFUL_WRITE:
      return {
        ...state,
        lastSuccessfulWrite: payload.lastSuccessfulWrite,
      };
    case actionTypes.ADD_PENDING_WRITE:
      return {
        ...state,
        pendingWrites: {
          ...state.pendingWrites,
          [action.payload.path]: [
            ...(state.pendingWrites[action.payload.path] || []),
            action.payload.hash,
          ],
        },
      };
    case actionTypes.REMOVE_PENDING_WRITE: {
      const pathPendingWrites = state.pendingWrites[action.payload.path] || [];
      const hashIndex = pathPendingWrites.indexOf(action.payload.hash);
      return {
        ...state,
        pendingWrites: {
          ...state.pendingWrites,
          [action.payload.path]: [
            ...pathPendingWrites.slice(0, hashIndex),
            ...pathPendingWrites.slice(hashIndex + 1),
          ],
        },
      };
    }
    default:
      return state;
  }
}

export const selectFirebaseApp = state => state.firebase.app;
export const selectFirebaseAuth = state => state.firebase.auth;
export const selectFirebaseHasCheckedLogin = state =>
  Object.keys(state.firebase.auth || {}).length > 0;
export const selectFirebaseAuthError = state => state.firebase.authError;
export const selectAuthJwt = state => state.firebase.auth.token;
